const overrides = window.pet_env || {}

export const VUE_APP_I18N_LOCALE = overrides.VUE_APP_I18N_LOCALE || process.env.VUE_APP_I18N_LOCALE
export const VUE_APP_I18N_FALLBACK_LOCALE = overrides.VUE_APP_I18N_FALLBACK_LOCALE || process.env.VUE_APP_I18N_FALLBACK_LOCALE
export const VUE_APP_ROOT_API = overrides.VUE_APP_ROOT_API || process.env.VUE_APP_ROOT_API
export const VUE_APP_LOKAL_ACTIVE = overrides.VUE_APP_LOKAL_ACTIVE || process.env.VUE_APP_LOKAL_ACTIVE
export const VUE_APP_LOKAL_APP_UNIQUEKEY = overrides.VUE_APP_LOKAL_APP_UNIQUEKEY || process.env.VUE_APP_LOKAL_APP_UNIQUEKEY
export const VUE_APP_LOKAL_EN_UNIQUEKEY = overrides.VUE_APP_LOKAL_EN_UNIQUEKEY || process.env.VUE_APP_LOKAL_EN_UNIQUEKEY
export const VUE_APP_LOKAL_FR_UNIQUEKEY = overrides.VUE_APP_LOKAL_FR_UNIQUEKEY || process.env.VUE_APP_LOKAL_FR_UNIQUEKEY
